import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined';
import CompanyInfoCard from './CompanyInfoCard';
import CompanyOutreachOutcomeDialog from './CompanyOutreachOutcomeDialog';
import TrialOutreachPill from '../../trial-outreach/components/TrialOutreachPill';
import { GetAdminTrialOutreachOutcomeAPI } from '../../../../api/AdminAPI';
import { outcomeOption, REASON_OPTIONS } from '../../trial-outreach/trialOutreachOutcomes';

/**
 * 'Y-m-d H:i:s' -> "16/10/2026".
 * @param {string|null} value
 * @returns {string}
 */
function fmtDate(value) {
  if (!value) return '—';
  const date = new Date(String(value).replace(' ', 'T'));
  return Number.isNaN(date.getTime()) ? '—' : date.toLocaleDateString('pt-BR');
}

/**
 * CompanyOutreachOutcomeCard - Resultado do contato com a conta (Admin Geral > empresa):
 * respondeu, vai voltar ou descartado com o motivo. Busca e salva sozinho.
 * @param {Object} props
 * @param {{ id: number|string, name: string }} props.company
 */
function CompanyOutreachOutcomeCard({ company }) {
  const [outcome, setOutcome] = useState(null);
  const [loading, setLoading] = useState(true);
  const [dialogOpen, setDialogOpen] = useState(false);

  useEffect(() => {
    let active = true;
    setLoading(true);
    GetAdminTrialOutreachOutcomeAPI(company.id, (response) => {
      if (!active) return;
      setOutcome(response?.success ? response.outcome || null : null);
      setLoading(false);
    });
    return () => {
      active = false;
    };
  }, [company.id]);

  const option = outcomeOption(outcome?.outcome);
  const reason = REASON_OPTIONS.find((item) => item.value === outcome?.reason);

  const rows = option
    ? [
        { label: 'Resultado', value: <TrialOutreachPill tone={option.tone} label={option.label} /> },
        reason && { label: 'Motivo', value: reason.label },
        outcome.note && {
          label: 'Observação',
          value: (
            <Typography component="span" variant="body2" sx={{ fontWeight: 600, wordBreak: 'break-word', whiteSpace: 'pre-wrap' }}>
              {outcome.note}
            </Typography>
          ),
        },
        { label: 'Marcado em', value: `${fmtDate(outcome.at)} · ${outcome.by || '—'}` },
      ].filter(Boolean)
    : [{ label: 'Resultado', value: loading ? 'Carregando...' : 'Sem resultado' }];

  return (
    <>
      <CompanyInfoCard
        icon={<ForumOutlinedIcon fontSize="small" />}
        title="Resultado do contato"
        rows={rows}
        footer={
          <Button
            size="small"
            variant="outlined"
            onClick={() => setDialogOpen(true)}
            disabled={loading}
            sx={{ alignSelf: 'flex-start', textTransform: 'none', mt: 'auto' }}
          >
            Marcar resultado
          </Button>
        }
      />

      <CompanyOutreachOutcomeDialog
        isOpen={dialogOpen}
        company={company}
        current={outcome}
        onSaved={(saved) => {
          setOutcome(saved);
          setDialogOpen(false);
        }}
        onCancel={() => setDialogOpen(false)}
      />
    </>
  );
}

export default CompanyOutreachOutcomeCard;
